/**
 * Catálogo vivo — la base de datos manda, el código es respaldo.
 *
 * Carga /api/catalog/bundle una sola vez y MUTA EN SITIO los arrays/mapas
 * estáticos (artists, salas, events, performances, ARTIST_TRANSLATIONS).
 * Así, todos los consumidores existentes (páginas y helpers como
 * pickArtistField / getArtist / getArtistByQrSlug) reciben los datos vivos
 * sin cambiar una sola línea, y las URLs/QR permanecen intactos.
 *
 * useCatalogVersion() dispara un re-render cuando llega el bundle.
 * Si la API falla, todo sigue funcionando con los datos estáticos.
 */
import { useEffect, useState } from "react";
import { artists, ARTIST_TRANSLATIONS, slugifyTitle } from "./artists";
import { salas } from "./salas";
import { events, performances } from "./agenda";

let version = 0;
let loaded = false;
let loading = false;
const subs = new Set();

function replaceArray(target, source) {
  target.length = 0;
  target.push(...source);
}

function applyBundle(d) {
  if (!d || !Array.isArray(d.artists) || !d.artists.length) return;
  // qrSlug: mismo cálculo que hace artists.js al importarse (cubre ítems
  // creados a mano en la DB sin qrSlug)
  d.artists.forEach((a) => {
    if (!a.qrSlug) {
      const tp = slugifyTitle(a.title);
      a.qrSlug = tp ? `${a.slug}-${tp}` : a.slug;
    }
  });
  replaceArray(artists, d.artists);
  if (d.artistTranslations) {
    Object.keys(ARTIST_TRANSLATIONS).forEach((k) => delete ARTIST_TRANSLATIONS[k]);
    Object.assign(ARTIST_TRANSLATIONS, d.artistTranslations);
  }
  if (Array.isArray(d.salas) && d.salas.length) replaceArray(salas, d.salas);
  if (Array.isArray(d.events)) replaceArray(events, d.events);
  if (Array.isArray(d.performances)) replaceArray(performances, d.performances);
  loaded = true;
  version += 1;
  subs.forEach((f) => f(version));
}

export function loadCatalog() {
  if (loaded || loading) return;
  loading = true;
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/catalog/bundle`)
    .then((r) => (r.ok ? r.json() : null))
    .then(applyBundle)
    .catch(() => {})
    .finally(() => {
      loading = false;
    });
}

/** Suscribe un componente al catálogo vivo (re-render al llegar la DB). */
export function useCatalogVersion() {
  const [, setV] = useState(version);
  useEffect(() => {
    loadCatalog();
    const f = (v) => setV(v);
    subs.add(f);
    return () => subs.delete(f);
  }, []);
}

/** Fuerza una recarga desde la DB (p. ej. tras editar en el admin). */
export function refreshCatalog() {
  loaded = false;
  loadCatalog();
}
